<template>
  <div :class="classOfDiv" v-if="list.length > 1">
    <v-autocomplete
      @change="myChange"
      :items="list"
      :disabled="isDisabled"
      v-model="branchOfficeList"
      no-data-text="Sin resultados"
      label="Sucursal"
      append-icon="mdi-hospital-building"
      clearable
      :dense="dense"
    />
    <!-- v-on:input="updateValue($event.target.value)"-->
  </div>
</template>
<script>
export default {
  name: "BranchOfficesList",
  props: {
    onChage: Function,
    isDisabled: Boolean,
    dense: Boolean,
    classOfDiv: String,
    model: String,
  },
  data: () => ({
    list: [],
    branchOfficeList: {},
    key: "id_branch",
  }),
  beforeMount() {
    this.listBranchOffices();
    // const key =  btoa(this.key);
    // const value = localStorage.getItem(key);
    if (
      this.$utilFront.nonEmpty(this.model) &&
      this.model != this.branchOfficeList
    ) {
      this.branchOfficeList = this.model;
      // this.branchOfficeList = atob(value);
      // this.myChange();
    }
  },
  methods: {
    listBranchOffices() {
      try {
        this.list = [];
        this.list = this.$utilFront.getBranchOffices().map((it) => {
          return { text: it.branchOfficeName, value: it.idBranchOffice };
        });

        try {
          if (this.$utilFront.nonEmptyList(this.list)) {
            if (this.list[0].value.includes("-")) {
              this.list.sort((a, b) => {
                return (
                  parseInt(a["value"].split("-")[1]) - parseInt(b["value"].split("-")[1])
                );
              });
            }
          }
        } catch (e) {
          console.log(e);
        }


      } catch (e) {
        console.error(e);
      }
    },
    myChange() {
      // this.model = this.branchOfficeList;
      // const key =  btoa(this.key);
      // localStorage.removeItem(key);

      // if(this.$utilFront.nonEmpty(this.model)){
      //   const value = btoa(this.model);
      //   localStorage.setItem(key, value);
      //   // console.log(atob(value));
      // }

      this.$emit("triggerChange", this.branchOfficeList);
    },
  },
};
</script>
<style>
.v-autocomplete.v-select--is-menu-active .v-input__icon--append .v-icon {
  transform: none !important;
}
</style>
